import moment from 'moment';
import { WTypography } from '../../wrappers/wrapper';
import styles from './article-owner.module.scss';
import { TUser } from '../../../models/common';
import ProfilePhoto from 'components/molecules/profile-photo/profile-photo';

export function ArticleOwner({
  user,
  fromNowValue,
  onClick,
}: {
  user: TUser;
  fromNowValue?: moment.MomentInput;
  onClick?: () => any;
}) {
  if (!user) return null;
  return (
    <div className={styles.articleOwner} onClick={onClick}>
      <ProfilePhoto user={user} width="2.5rem" height="2.5rem" radius="100%" fontSize="1rem" />
      <div>
        <div className={styles.details}>
          <WTypography>{user.username}</WTypography>
          {fromNowValue && <WTypography>{moment(fromNowValue).fromNow()}</WTypography>}
        </div>
        {(user.job?.length || 0) > 0 && (
          <WTypography className={styles['job']}>{user.job}</WTypography>
        )}
      </div>
    </div>
  );
}
